import React, { useEffect, useState } from 'react'
import { useCurrent } from '../../../hooks';
import FormLangBar from '../../FormLangBar';
import { MwInputText, MwSelector, MwSwitch, MwTextArea } from '../../ui';
import { useTranslation } from 'react-i18next';
import {
    getProductTypeOptions,
    PRODUCT_FORM_SECTION_CLASS,
    PRODUCT_OPTION_LABEL_CLASS,
    PRODUCT_OPTION_ROW_CLASS,
} from '../productUi';

const BaiscInfo = ({
        productName,
        setProductName,
        productDesc,
        setProductDesc,
        isShowOnWebsite,
        setIsShowOnWebsite,
        isActive,
        setIsActive,
        errors,
        productTypeSelected,
        setProductTypeSelected
    }) => {
    const {currentLangList,currentLangId} = useCurrent();
    const [formLang,setFormLang] = useState(currentLangId);
    const [t,i18n ] = useTranslation('global')

    useEffect(() => {
        setFormLang(i18n.language);
      }, [i18n.language]);
      
    const filteredProductTypeList = getProductTypeOptions(t);

    return (
        <div className='space-y-4'>
            <FormLangBar formLang={formLang} setFormLang={setFormLang} currentLangList = {currentLangList}/>
            <div className={PRODUCT_FORM_SECTION_CLASS}>
                { currentLangList.map((lang) => (
                    <div key={lang.langCode}>
                        <div className={` ${ formLang === lang?.langCode ? 'block' : 'hidden' } `}>
                            <MwInputText
                                label={`${t('product.product_name')} (${lang?.langName})`}
                                id={`productName_${lang?.langCode}`} 
                                value={productName[lang?.langCode]}
                                placeholder={`${t('product.product_name')} (${lang?.langName})`}
                                invalid={!!errors[`productName.${lang?.langCode}`] }
                                invalidMsg = {errors[`productName.${lang?.langCode}`]}
                                onChange={(e)=>{
                                    setProductName({...productName, [lang?.langCode]:e.target.value});
                                }}
                            />
                            <div className='mt-3'>
                                <MwTextArea
                                    id={`productDesc_${lang?.langCode}`}
                                    label={`${t('product.product_description_with_lang')} (${lang.langName})`}
                                    value={productDesc[lang?.langCode]}
                                    placeholder={`${t('product.product_description_with_lang')} (${lang.langName})`}
                                    rows={3}
                                    onChange={(e) => setProductDesc({...productDesc,[lang?.langCode]:e.target.value})}
                                />
                            </div>
                        </div>
                    </div>
                )) }
            </div>
            <div className={PRODUCT_FORM_SECTION_CLASS}>
                <MwSelector
                    label = {t('product.product_type') }
                    initalValue ={t('product.choose_product_type')} 
                    _data = {filteredProductTypeList }
                    dataType = 'labelValue'
                    withAddNew = {false}
                    withSearch = {false}
                    selectedItem = {productTypeSelected}
                    setSelectedItem = {setProductTypeSelected}
                    invalid = {!!errors?.productType}
                    invalidMsg = {errors?.productType}
                    />
            </div>
            <div id='OptionsBock' className='flex flex-col gap-3'>
                <div className={PRODUCT_OPTION_ROW_CLASS}>
                    <label className={PRODUCT_OPTION_LABEL_CLASS}>  {t('product.website_visibility')} </label>
                    <MwSwitch custKey='isActive' isActive={isShowOnWebsite} setIsActive={setIsShowOnWebsite} onChangeSwitch={()=> setIsShowOnWebsite(!isShowOnWebsite)} />
                </div>
                <div className={PRODUCT_OPTION_ROW_CLASS}>
                    <label className={PRODUCT_OPTION_LABEL_CLASS}>   {t('product.activation_status')}    </label>
                    <MwSwitch custKey='isActive' isActive={isActive} setIsActive={setIsActive} onChangeSwitch={() => setIsActive(!isActive)} />
                </div>
            </div>
        </div>
    )
}

export default BaiscInfo
